/** @internal */
export const COMPONENT_NAME = 'Menu';
